import axios from 'axios'
import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  allVouchers: [],
  vouchers: [],

  promotionDialog: false,
  voucherItemDialog: false,
  promotionVoucher: null,
  promotionItem: null
}

// getters
export const getters = {
  voucherMsg: state => state.msg,
  allVouchers: state => state.allVouchers,
  vouchers: state => state.vouchers,

  promotionDialog: state => state.promotionDialog,
  promotionVoucher: state => state.promotionVoucher,
  promotionItem: state => state.promotionItem,
  voucherItemDialog: state => state.voucherItemDialog,

  discounts: state => {
    return state.vouchers.filter(v => parseInt(v.gems_member_voucher.VoucherType) === 0 &&
      (!v.gems_member_voucher.DiscountType || parseInt(v.gems_member_voucher.DiscountType) === 0) &&
      (v.gems_member_voucher.UnlimitedUse || (!v.gems_member_voucher.UnlimitedUse && !v.used))
    )
  }
}

// mutations
export const mutations = {
  [types.RESET_VOUCHER_DATA] (state) {
    Object.assign(state, {
      msg: null,
      allVouchers: [],
      vouchers: [],

      promotionDialog: false,
      voucherItemDialog: false,
      promotionVoucher: null,
      promotionItem: null
    })
  },

  [types.SET_VOUCHER_MSG] (state, msg) {
    const msgs = {
      voucher: 'Failed to fetch vouchers'
    }
    state.msg = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch vouchers'
  },

  [types.RESET_VOUCHER_MSG] (state) {
    state.msg = null
  },

  [types.FETCH_ALL_VOUCHERS] (state, vouchers) {
    state.allVouchers = vouchers
  },

  [types.FETCH_VOUCHERS] (state, vouchers) {
    state.vouchers = vouchers
  },

  [types.RESET_VOUCHERS] (state) {
    state.vouchers = []
  },

  [types.SHOW_PROMOTION_DIALOG] (state) {
    state.promotionDialog = true
  },

  [types.HIDE_PROMOTION_DIALOG] (state) {
    state.promotionDialog = false
  },

  [types.SET_PROMOTION_VOUCHER] (state, voucher) {
    state.promotionVoucher = voucher
  },

  [types.RESET_PROMOTION_VOUCHER] (state) {
    state.promotionVoucher = null
  },

  [types.SET_PROMOTION_ITEM] (state, item) {
    state.promotionItem = item
  },

  [types.RESET_PROMOTION_ITEM] (state) {
    state.promotionItem = null
  },

  [types.SHOW_VOUCHER_ITEM_DIALOG] (state) {
    state.voucherItemDialog = true
  },

  [types.HIDE_VOUCHER_ITEM_DIALOG] (state) {
    state.voucherItemDialog = false
  }
}

// actions
export const actions = {
  resetVoucherData ({ commit }) {
    commit(types.RESET_VOUCHER_DATA)
  },

  async fetchAllVouchers ({ commit, rootGetters }) {
    commit(types.RESET_VOUCHER_MSG)
    try {
      const { data } = await axios.post('/api/vouchers/all', {
        group_id: parseInt(rootGetters['config/gid']),
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
      })
      if (data.code === 1) {
        commit(types.FETCH_ALL_VOUCHERS, data.vouchers)
      } else {
        commit(types.SET_VOUCHER_MSG, 'voucher')
      }
    } catch (e) {
      commit(types.SET_VOUCHER_MSG, 'voucher')
    }
  },

  async fetchMyVouchers ({ commit, state, rootGetters }) {
    commit(types.RESET_VOUCHER_MSG)
    try {
      const { data } = await axios.post('/api/vouchers/my', {
        group_id: rootGetters['config/gid'],
        loyalty_group_id: rootGetters['config/loyaltyGroupId'],
        restaurant_id: rootGetters['config/rid']
      })
      if (data.code === 1) {
        commit(types.FETCH_VOUCHERS, data.vouchers)
      } else {
        commit(types.SET_VOUCHER_MSG, 'voucher')
      }
    } catch (e) {
      commit(types.SET_VOUCHER_MSG, 'voucher')
    }
  },

  async fetchGuestVouchers ({ commit, state, rootGetters }) {
    commit(types.RESET_VOUCHER_MSG)
    try {
      const { data } = await axios.post('/api/vouchers/guest', {
        group_id: rootGetters['config/gid'],
        guest_id: rootGetters['config/guestId'],
        restaurant_id: rootGetters['config/rid']
      })
      if (data.code === 1) {
        commit(types.FETCH_VOUCHERS, data.vouchers)
      } else {
        commit(types.SET_VOUCHER_MSG, 'voucher')
      }
    } catch (e) {
      commit(types.SET_VOUCHER_MSG, 'voucher')
    }
  },

  async setPromotionVoucher ({ commit, dispatch, rootGetters }, payload) {
    // payload is voucher
    const gv = payload.gems_member_voucher
    const item = payload.item
    if (gv && parseInt(gv.VoucherType) === 1 && gv.PLUID) {
      if (item) {
        let itemWithCourses = null
        if (item.has_courses) {
          // fetch menu cat item
          itemWithCourses = rootGetters['menu/items']['c' + item.category_id].find(i => i.item_id === item.item_id)
        }
        commit(types.RESET_VOUCHER_MSG)
        commit(types.SET_PROMOTION_ITEM, itemWithCourses || item)
        commit(types.SET_PROMOTION_VOUCHER, payload)
        await dispatch('menu/setMenuItem', itemWithCourses || item, { root: true })
      } else {
        commit(types.SET_VOUCHER_MSG, 'item2')
        commit(types.RESET_PROMOTION_ITEM)
        commit(types.SET_PROMOTION_VOUCHER, payload)
        dispatch('menu/resetMenuItem', null, { root: true })
      }
    } else {
      commit(types.RESET_VOUCHER_MSG)
      commit(types.RESET_PROMOTION_ITEM)
      commit(types.SET_PROMOTION_VOUCHER, payload)
      dispatch('menu/resetMenuItem', null, { root: true })
    }
  },

  resetPromotionVoucher ({ commit, dispatch }) {
    commit(types.RESET_PROMOTION_ITEM)
    commit(types.RESET_PROMOTION_VOUCHER)
    dispatch('menu/resetMenuItem', null, { root: true })
  },

  showPromotionDialog ({ commit }) {
    // payload is voucher
    commit(types.SHOW_PROMOTION_DIALOG)
  },

  hidePromotionDialog ({ commit }) {
    commit(types.HIDE_PROMOTION_DIALOG)
  },

  resetPromotionDialog ({ commit }) {
    commit(types.HIDE_PROMOTION_DIALOG)
  },

  showVoucherItemDialog ({ commit, dispatch }, payload) {
    // payload is item
    commit(types.SHOW_VOUCHER_ITEM_DIALOG)
  },

  hideVoucherItemDialog ({ commit, dispatch }) {
    commit(types.HIDE_VOUCHER_ITEM_DIALOG)
    // dispatch('menu/cleanMenuItem', null, { root: true })
    // dispatch('menu/resetMenuItem', null, { root: true })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/voucher.js